import { themeApp } from "@/configs/theme";
import { ThemeProvider, createTheme } from "@mui/material";
import { Outlet } from "react-router-dom";
import DrawerMenu from "./drawer";
import Header from "./header";

const theme = createTheme(themeApp);

const Layout = () => {
  return (
    <ThemeProvider theme={theme}>
      <div className="flex min-h-dvh bg-[#f6f9fb]">
        <DrawerMenu />
        <div
          id="main-content"
          className="mx-5 flex min-h-screen w-full flex-1 flex-col overflow-auto py-5 lg:mx-10 lg:py-6"
        >
          <Header />
          <div className="flex-1">
            <Outlet />
          </div>
        </div>
      </div>
    </ThemeProvider>
  );
};

export default Layout;
